import { useForm } from 'react-hook-form'
import { zodResolver } from '@hookform/resolvers/zod'
import { detailsSchema, type DetailsInput } from 'shared'
import Select from '../ui/Select'
import Button from '../ui/Button'
import type { PatientRecord } from 'shared'

interface Step2Props {
  initialData?: Partial<PatientRecord>
  onNext: (data: Partial<PatientRecord>) => void
  onBack: () => void
}

const Step2Details = ({ initialData, onNext, onBack }: Step2Props) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<DetailsInput>({
    mode: 'onBlur',
    resolver: zodResolver(detailsSchema),
    defaultValues: initialData?.details,
  })

  const onSubmit = (data: DetailsInput) => {
    onNext({ details: data })
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="max-w-5xl mx-auto">
      <h2 className="text-xl font-medium text-neutral-800 mb-6">詳細情報</h2>

      <div className="space-y-5">
        {/* 来店きっかけ */}
        <Select
          {...register('visitSource')}
          label="来店きっかけ"
          error={errors.visitSource?.message}
          required
        >
          <option value="">選択してください</option>
          <option value="Hotpepper">Hotpepper</option>
          <option value="Web検索">Web検索</option>
          <option value="Instagram">Instagram</option>
          <option value="X">X (Twitter)</option>
          <option value="地元情報誌">地元情報誌</option>
          <option value="口コミ">口コミ</option>
          <option value="その他">その他</option>
        </Select>

        {/* 職業 */}
        <Select
          {...register('occupation')}
          label="職業"
          error={errors.occupation?.message}
        >
          <option value="">選択してください</option>
          <option value="会社員">会社員</option>
          <option value="自営業">自営業</option>
          <option value="主婦">主婦</option>
          <option value="学生">学生</option>
          <option value="その他">その他</option>
        </Select>
      </div>

      <div className="mt-8 flex justify-between gap-4">
        <Button type="button" variant="secondary" size="large" onClick={onBack} className="min-w-[140px]">
          戻る
        </Button>
        <Button type="submit" variant="primary" size="large" className="min-w-[200px]">
          次へ進む
        </Button>
      </div>
    </form>
  )
}

export default Step2Details
